import {
    DEALERDSRLIST_SUCCESS,
    DEALERDSRLIST_FAILED,
    RESET_DEALERDSRLIST,
    LOADING_DEALERDSRLIST,
    NETWORK_ERROR_DEALERDSRLIST
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERDSRLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERDSRLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERDSRLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERDSRLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERDSRLIST:
            return (state = initialState);
        default:
            return state;
    }
};